import { render, staticRenderFns } from "./LabelReleasesExportDialog.vue?vue&type=template&id=2aaa4efc"
import script from "./LabelReleasesExportDialog.vue?vue&type=script&lang=js"
export * from "./LabelReleasesExportDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports